import { defineComponent, computed, openBlock, createElementBlock, createElementVNode } from 'vue';
import { UiIconPropsOption, UiIconEmits } from './index.mjs';

const _hoisted_1 = ["xlink:href"];
const __default__ = defineComponent({ name: "UiIcon" });
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: UiIconPropsOption,
  emits: UiIconEmits,
  setup(__props, { emit: __emit }) {
    const define = __props;
    const emits = __emit;
    const click = (ev) => emits("click", ev);
    const name = computed(() => {
      return `#icon-${define.name}`;
    });
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", {
        class: "ui-icon",
        "aria-hidden": "true",
        onClick: click
      }, [
        createElementVNode("use", { "xlink:href": name.value }, null, 8, _hoisted_1)
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
